import IconCheck from 'assets/icons/check.svg';
import cn from 'classnames';
import Badge from 'components/badge';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CARD_TYPES } from '.';

interface Props {
  type: CARD_TYPES;
}

const InCartBadge: FC<Props> = ({ type }) => (
  <div
    className={cn(
      type === CARD_TYPES.REGULAR
        ? 'lg:absolute lg:bottom-0 lg:-left-2'
        : 'absolute bottom-0 -left-2 z-10',
      type === CARD_TYPES.SLIDER && 'lg:-left-4'
    )}
    data-test="in-cart-badge"
  >
    <Badge
      type="Neutral"
      size="inherit"
      className={cn(
        'text-text-light-bg-secondary text-sm',
        type === CARD_TYPES.REGULAR
          ? 'lg:rounded-l-none lg:rounded-r lg:pl-1 lg:leading-normal'
          : 'rounded-l-none rounded-r pl-1 leading-normal'
      )}
    >
      <span className="flex items-center gap-1" data-test="in-cart-badge-content">
        <IconCheck className="h-4 w-4 shrink-0" />
        <span data-test="in-cart-badge-text">
          <FormattedMessage id="cdp:ab-test:product-card:in-cart" />
        </span>
      </span>
    </Badge>
  </div>
);

export default InCartBadge;
